import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'stairs', 'Stairs', [["path",{"d":"M22 5h-5v5h-5v5h-5v5h-5"}]]);